import React from 'react';
import { Controller } from 'react-hook-form';
import {
  Grid, Paper, Box, Button, TextField, Typography,
} from '@mui/material';
import { PasswordInput } from '@resolvvi/pink-flow';
import { useEditContext } from '../context';
import ConfirmUpdateDialog from './ConfirmUpdateDialog';

const Form = ():JSX.Element => {
  const {
    profile, errors, register, control, setShowConfirmUpdateDialog,
  } = useEditContext();

  return (
    <Grid
      size={{
        xs: 12,
        md: 10,
        lg: 8,
        xl: 6,
      }}
    >
      <Paper elevation={0}>
        <Box padding={3}>
          <Grid container spacing={1}>
            <Grid size={12}>
              <Typography fontWeight={600} color="textSecondary">Dados pessoais</Typography>
            </Grid>
            <Grid size={12}>
              <TextField label="Nome" defaultValue={profile?.name} {...register?.('name')} required fullWidth />
              <Typography variant="caption" color="error">{errors?.name?.message as string}</Typography>
            </Grid>
            <Grid size={12}>
              <TextField label="E-mail" defaultValue={profile?.email} {...register?.('email')} required fullWidth />
              <Typography variant="caption" color="error">{errors?.email?.message as string}</Typography>
            </Grid>
            <Grid size={12}>
              <Box marginTop={3}>
                <Typography fontWeight={600} color="textSecondary">Alterar senha</Typography>
              </Box>
            </Grid>
            <Grid size={12}>
              <Controller
                name="newPassword"
                control={control}
                render={({ field }) => (
                  <PasswordInput label="Nova senha" value={field.value} onChange={field.onChange} />
                )}
              />
              <Typography variant="caption" color="error">{errors?.newPassword?.message as string}</Typography>
            </Grid>
            <Grid size={12}>
              <Controller
                name="newPasswordConfirmation"
                control={control}
                render={({ field }) => (
                  <PasswordInput label="Confirmar nova senha" value={field.value} onChange={field.onChange} />
                )}
              />
              <Typography variant="caption" color="error">{errors?.newPasswordConfirmation?.message as string}</Typography>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      <Box display="flex" flex="1" justifyContent="flex-end" marginTop={3}>
        <Button variant="contained" color="primary" size="large" onClick={() => setShowConfirmUpdateDialog(true)}>
          Editar perfil
        </Button>
      </Box>
      <ConfirmUpdateDialog />
    </Grid>
  );
};

export default Form;
